module.exports = __webpack_public_path__ + "img/样例4.130fd6dd.png";